module.exports = __webpack_public_path__ + "static/img/5.dedf321.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/history/premedical/5.png
// module id = 3GZi
// module chunks = 1